/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A normalized building amenity
 */
export enum BuildingAmenity {
    _24_HOUR_MAINTENANCE = '24_hour_maintenance',
    ACCEPTS_HOUSING_VOUCHER = 'accepts_housing_voucher',
    ADA_COMPLIANT = 'ada_compliant',
    ADDITIONAL_STORAGE_SPACE_OUTSIDE_UNIT = 'additional_storage_space_outside_unit',
    ART_STUDIO = 'art_studio',
    ATTACHED_GARAGE = 'attached_garage',
    BASKETBALL_COURT = 'basketball_court',
    BIKE_RACK = 'bike_rack',
    BILINGUAL = 'bilingual',
    BOAT_DOCK = 'boat_dock',
    BOCCEBALL_COURT = 'bocceball_court',
    BUSINESS_CENTER = 'business_center',
    CABANA = 'cabana',
    CARPORT = 'carport',
    CATS_ALLOWED = 'cats_allowed',
    CLUB_HOUSE_PARTY_ROOM = 'club_house_party_room',
    BARBECUE_GRILL = 'barbecue_grill',
    COMMUNITY_CHEF_KITCHEN_SPACE = 'community_chef_kitchen_space',
    COMMUNITY_DOG_PARK = 'community_dog_park',
    COMMUNITY_GARDEN = 'community_garden',
    COMMUNITY_PET_WASHING_STATION = 'community_pet_washing_station',
    COMMUNITY_ROOM = 'community_room',
    COMMUNITY_WIFI = 'community_wifi',
    COMPUTER_LAB = 'computer_lab',
    CONTROLLED_ACCESS = 'controlled_access',
    CORPORATE_SUITE = 'corporate_suite',
    COURTYARD = 'courtyard',
    DAYCARE = 'daycare',
    DETACHED_GARAGE = 'detached_garage',
    DISPOSAL_CHUTES = 'disposal_chutes',
    DOGS_ALLOWED = 'dogs_allowed',
    DOORMAN = 'doorman',
    ELECTRIC_CAR_CHARGING_STATION = 'electric_car_charging_station',
    ELEVATOR = 'elevator',
    FIRE_PIT = 'fire_pit',
    FITNESS_CENTER = 'fitness_center',
    CONCIERGE = 'concierge',
    FOOSBALL = 'foosball',
    GAME_ROOM = 'game_room',
    GATED_COMMUNITY_ACCESS = 'gated_community_access',
    GOLF_SIMULATOR = 'golf_simulator',
    GREEN_COMMUNITY = 'green_community',
    GUEST_PARKING = 'guest_parking',
    GUEST_SUITE = 'guest_suite',
    HISTORIC_BUILDING = 'historic_building',
    HOT_TUB = 'hot_tub',
    HOUSEKEEPING_AVAILABLE = 'housekeeping_available',
    INCOME_RESTRICTED = 'income_restricted',
    INTERNET_LOUNGE = 'internet_lounge',
    LANDSCAPING = 'landscaping',
    LAUNDRY_SERVICE = 'laundry_service',
    LAUNDRY_ROOM = 'laundry_room',
    LIBRARY = 'library',
    LOBBY = 'lobby',
    LOUNGE = 'lounge',
    MASSAGE_ROOM = 'massage_room',
    MULTIMEDIA_CENTER = 'multimedia_center',
    SATISFACTION_GUARANTEED = 'satisfaction_guaranteed',
    ON_SITE_CAR_WASH = 'on_site_car_wash',
    ON_SITE_MAINTENANCE = 'on_site_maintenance',
    ON_SITE_MANAGEMENT = 'on_site_management',
    ONE_CAR_GARAGE = 'one_car_garage',
    ONLINE_PAYMENT_PORTAL = 'online_payment_portal',
    ORGANIC_WASTE_COMPOSTING = 'organic_waste_composting',
    PACKAGE_LOCKERS = 'package_lockers',
    PACKAGE_RECEIVING = 'package_receiving',
    PARKING_GARAGE = 'parking_garage',
    PARKING_INCLUDED = 'parking_included',
    PET_DAYCARE_SERVICE = 'pet_daycare_service',
    PETS_ALLOWED = 'pets_allowed',
    PICKLEBALL_COURT = 'pickleball_court',
    PICNIC_AREA = 'picnic_area',
    PLAYGROUND = 'playground',
    POOL_TABLE = 'pool_table',
    PUTTING_GREEN = 'putting_green',
    RACQUETBALL_COURT = 'racquetball_court',
    RECYCLING = 'recycling',
    RESERVED_PARKING = 'reserved_parking',
    RESIDENT_EVENTS = 'resident_events',
    RESIDENT_REFERRAL_PROGRAM = 'resident_referral_program',
    RESIDENT_REWARDS_PROGRAM = 'resident_rewards_program',
    ROCK_CLIMBING_WALL = 'rock_climbing_wall',
    ROOFTOP_SPACE = 'rooftop_space',
    ROOMMATE_MATCHING = 'roommate_matching',
    SAUNA = 'sauna',
    SECURE_RESIDENT_PARKING = 'secure_resident_parking',
    SECURED_COVERED_BIKE_STORAGE = 'secured_covered_bike_storage',
    SECURITY_SYSTEM = 'security_system',
    SHARED_OFFICE_SPACE = 'shared_office_space',
    SHORT_TERM_LEASE_OPTIONS = 'short_term_lease_options',
    SHUFFLE_BOARD = 'shuffle_board',
    NON_SMOKING = 'non_smoking',
    SNOW_REMOVAL = 'snow_removal',
    SOCCER_FIELD = 'soccer_field',
    SPA = 'spa',
    SPORT_COURT = 'sport_court',
    SUNROOM = 'sunroom',
    SWIMMING_POOL = 'swimming_pool',
    TABLE_TENNIS = 'table_tennis',
    TANNING_BEDS = 'tanning_beds',
    TENNIS_COURT = 'tennis_court',
    TERRACE = 'terrace',
    TWO_CAR_GARAGE = 'two_car_garage',
    VALET_TRASH_SERVICE = 'valet_trash_service',
    VOLLEYBALL_COURT = 'volleyball_court',
    WATERFRONT = 'waterfront',
    WORKSHOP = 'workshop',
    YOGA_STUDIO = 'yoga_studio',
    ZEN_GARDEN = 'zen_garden',
}
